import { inject, Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, finalize, map, retry, shareReplay, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

export interface SalesProcessStatusResponse {
  status: string;
  data: { isActive: boolean };
}

@Injectable({
  providedIn: 'root'
})
export class PcaStatusService {
  public isActive = signal<boolean | null>(null);

  private http = inject(HttpClient);
  private isLoading = signal<boolean>(false);
  private cachedStatus$: Observable<boolean> | null = null;

  public getProcessStatus(url: string): Observable<boolean> {
    if (this.cachedStatus$) {
      return this.cachedStatus$;
    }

    this.cachedStatus$ = this.fetchActiveStatus(url).pipe(shareReplay(1));

    return this.cachedStatus$;
  }

  private fetchActiveStatus(url: string): Observable<boolean> {
    return this.http.get<SalesProcessStatusResponse>(`${url}/pca-sales-process/process-status`).pipe(
      map((res) => res.data.isActive),
      retry(2),
      catchError(() => {
        this.isActive.set(false);
        return of(false);
      }),
      tap((result) => {
        this.isActive.set(result);
      }),
      finalize(() => this.isLoading.set(false))
    );
  }
}
